// also contains global AS2 functions
var AS2SystemAdapter = (function () {
    function AS2SystemAdapter() {
    }
    return AS2SystemAdapter;
}());
export { AS2SystemAdapter };
AS2SystemAdapter.security = null;
AS2SystemAdapter.capabilities = { version: 6 };



// WEBPACK FOOTER //
// ../dist/lib/adapters/AS2SystemAdapter.js